import PropTypes from 'prop-types';
import React from 'react';

import { isLocalURL } from '$utilities/browser.js';
import { formatLinkBlockToUrl } from '$utilities/format.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleCtaBlock = ({
    ctaLabel = '',
    ctaLink = null,
    heading = '',
    text = ''
}) => {
    // misc
    const href = formatLinkBlockToUrl(ctaLink);
    const target = isLocalURL(href) ? '_self' : '_blank';
    const rel = isLocalURL(href) ? null : 'noreferrer noopener';

    // render
    return (
        <>
            <div className='layout-container relative md:flex pb-60 pt-40 sm:py-60 bg-blue'>
                <div className='md:w-1/12' />

                <div className='md:w-5/12 flex flex-col gap-y-20'>
                    {heading && (
                        <h2 className='type-style-3'>
                            {heading}
                        </h2>
                    )}

                    {text && (
                        <p className='type-style-4'>
                            {text}
                        </p>
                    )}

                    {(ctaLabel && ctaLink) && (
                        <p>
                            <a
                                className='pill-button'
                                href={href}
                                rel={rel}
                                target={target}>
                                {ctaLabel}
                            </a>
                        </p>
                    )}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.object,
    heading: PropTypes.string,
    text: PropTypes.string
};

ModuleCtaBlock.propTypes = propTypes;

export default ModuleCtaBlock;
